import "./SkeletonStyleDialog.moduleRenamed.css";

export const filterInputBoxWrapper = "SkeletonStyleDialog-module__filterInputBoxWrapper___x38O8";
export const filterInputBoxIcon = "SkeletonStyleDialog-module__filterInputBoxIcon___shF9a";
export const optionList = "SkeletonStyleDialog-module__optionList___kmMxu";
export const optionCategory = "SkeletonStyleDialog-module__optionCategory___Gx11J";
export const optionCategorySeparator = "SkeletonStyleDialog-module__optionCategorySeparator___KIGre";
export const optionCategoryTitle = "SkeletonStyleDialog-module__optionCategoryTitle___HMkUw";
export const optionItem = "SkeletonStyleDialog-module__optionItem___d0LtA";
export const optionTitle = "SkeletonStyleDialog-module__optionTitle___CCnC4";
export const optionContent = "SkeletonStyleDialog-module__optionContent___KsHeW";

export default {
  filterInputBoxWrapper: "SkeletonStyleDialog-module__filterInputBoxWrapper___x38O8",
  filterInputBoxIcon: "SkeletonStyleDialog-module__filterInputBoxIcon___shF9a",
  optionList: "SkeletonStyleDialog-module__optionList___kmMxu",
  optionCategory: "SkeletonStyleDialog-module__optionCategory___Gx11J",
  optionCategorySeparator: "SkeletonStyleDialog-module__optionCategorySeparator___KIGre",
  optionCategoryTitle: "SkeletonStyleDialog-module__optionCategoryTitle___HMkUw",
  optionItem: "SkeletonStyleDialog-module__optionItem___d0LtA",
  optionTitle: "SkeletonStyleDialog-module__optionTitle___CCnC4",
  optionContent: "SkeletonStyleDialog-module__optionContent___KsHeW",
};